<template>
  <div>
    token : {{ token }} btnGenerer
    insee
    <button type="button" class="btn btn-icon btn-round btn-default" @click="getToken">
      <font-awesome-icon icon="fa-solid fa-rotate"/>
    </button>
  </div>
</template>
<script>

import axios from "axios";

const options = {
  headers: {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }
};
export default {
  data() {
    return {
      token: null,
      key: 'T7c1hi8FwLCmxoyLRlT31FHjmwMa',
      secret: 'nSugz77P6h0xSSIfmbk2zHAL_4Qa'
    }
  },
  components: {},
  methods: {
    getToken: function () {

      try {
        // const b =  axios.post("https://api.insee.fr/token", {
        //   client_id: this.key,
        //   client_secret: this.secret,
        //   grant_type: "client_credentials",
        //   headers: {
        //     '': '',
        //     'Authorization': 'Basic VDdjMWhpOEZ3TENteG95TFJsVDMxRkhqbXdNYTpuU3Vnejc3UDZoMHhTU0lmbWJrMnpIQUxfNFFh',
        //     'Cookie': 'INSEE=2957558538.58148.0000; pdapimgateway=2907226890.22560.0000',
        //     'Content-Type': 'text/plain'
        //   },
        // }).then(response => {
        //   console.log(response)
        // });

        var axios = require('axios');
        var data = '<file contents here>';
        var config = {
          method: 'post',
          url: 'https://api.insee.fr/token?grant_type=client_credentials',
          headers: {
            'Authorization': 'Basic VDdjMWhpOEZ3TENteG95TFJsVDMxRkhqbXdNYTpuU3Vnejc3UDZoMHhTU0lmbWJrMnpIQUxfNFFh',
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
          },
          data: data

      }
        ;
        // axios(config)
        //     .then(function (response) {
        //       console.log(JSON.stringify(response.data));
        //     })
        //     .catch(function (error) {
        //       console.log(error);
        //     });
        var basicAuth = 'Basic ' + btoa(this.key + ':' + this.secret);
         axios.post('https://api.insee.fr/token?grant_type=client_credentials', {}, {
           headers: {
             headers: {
               'Authorization': + basicAuth,

             },
             'Content-Type': 'text/plain'
           },
          auth: {
            username: this.key,
            password: this.secret
          }
        }).then(function (response) {
              console.log(JSON.stringify(response.data));
             })

      } catch (error) {
        console.log(error);
      }
    }

  }
}
</script>
<style>
/*.moving-tab {*/
/*font-size: 15px !important;*/
/*    }*/
</style>
